import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight, Tag, TrendingUp, Sparkles } from "lucide-react";
import stopProcrastinationImage from "@/assets/blog/stop-procrastination-hero.jpg";
import cameraProductivityImage from "@/assets/blog/camera-productivity-hero.jpg";
import digitalToolsImage from "@/assets/blog/digital-tools-hero.jpg";
import testPrepImage from "@/assets/blog/test-preparation-hero.jpg";
import onlineLearningImage from "@/assets/blog/online-learning-community.jpg";
import studyWithMeScienceImage from "@/assets/blog/study-with-me-science.jpg";
import productivityAppsCollegeImage from "@/assets/blog/productivity-apps-college.jpg";
import organizationAppsCollegeImage from "@/assets/blog/organization-apps-college.jpg";
import selfGrowthAppsCollegeImage from "@/assets/blog/self-growth-apps-college.jpg";
import taskPlanningImage from "@/assets/blog/task-planning.jpg";
 import focusModernLearningImage from "@/assets/blog/focus-modern-learning-hero.jpg";

const blogPosts = [
  {
     slug: "why-focus-is-harder-than-ever",
     title: "Why Focus Is Harder Than Ever in Modern Learning Environments",
     excerpt: "A research-backed exploration of why maintaining attention in 2026 is so challenging for students, from digital distractions to mental health, with evidence-based solutions.",
     date: "2026-02-05",
     readTime: "18 min read",
     category: "Focus & Productivity",
     image: focusModernLearningImage,
     views: 3500
   },
   {
    slug: "task-management-tools-review",
    title: "I Tried 10 Task-Management Tools in University: Here's What Actually Worked",
    excerpt: "After testing Notion, Todoist, TickTick, Trello, ClickUp, Asana, Monday.com, Motion, and more throughout university, here's my honest review of what actually helped me stay productive.",
    date: "2025-01-22",
    readTime: "15 min read",
    category: "Productivity",
    image: taskPlanningImage,
    views: 3100
  },
  {
    slug: "paper-vs-digital-planning",
    title: "Paper Planners vs. Digital Calendars: Why I Use Both",
    excerpt: "Research shows paper users complete 53% more tasks than mobile users. But digital calendars excel at reminders and collaboration. Here's why the hybrid approach wins.",
    date: "2025-01-21",
    readTime: "10 min read",
    category: "Productivity",
    image: taskPlanningImage,
    views: 2800
  },
  {
    slug: "apps-boost-self-growth-college",
    title: "Apps that Boosted my Self-growth in College!",
    excerpt: "Discover the best self-growth apps for college students. From mental wellness and mindful phone usage to mood tracking and habit building, these 4 apps will help you grow.",
    date: "2024-12-16",
    readTime: "12 min read",
    category: "Self-Growth",
    image: selfGrowthAppsCollegeImage,
    views: 2600
  },
  {
    slug: "apps-boost-organization-college",
    title: "Apps that Boost my Organization in College!",
    excerpt: "Discover the best organization apps for college students. From 24/7 online study rooms to calendar management and note-taking, these 5 apps will help you stay organized.",
    date: "2024-12-16",
    readTime: "10 min read",
    category: "Productivity",
    image: organizationAppsCollegeImage,
    views: 2450
  },
  {
    slug: "apps-boost-productivity-college",
    title: "Apps that Boost my Productivity in College!",
    excerpt: "Discover the best productivity apps for college students. From 24/7 online study rooms to smart calendars and quiz makers, these 5 apps will help you stay organized and focused.",
    date: "2024-12-16",
    readTime: "10 min read",
    category: "Productivity",
    image: productivityAppsCollegeImage,
    views: 2300
  },
  {
    slug: "science-behind-study-with-me",
    title: "The Science Behind the Study With Me Trend",
    excerpt: "Discover the psychology and science behind why Study With Me videos are so effective. Learn about social facilitation, accountability, and how this trend helps millions stay focused.",
    date: "2024-12-16",
    readTime: "8 min read",
    category: "Productivity",
    image: studyWithMeScienceImage,
    views: 2100
  },
  {
    slug: "benefits-of-online-learning-community",
    title: "The 5 Benefits of Having an Online Learning Community",
    excerpt: "Discover the key benefits of joining an online learning community. From accountability and diverse perspectives to networking and accelerated learning, learn how OLCs can transform your education.",
    date: "2024-12-16",
    readTime: "10 min read",
    category: "Online Learning",
    image: onlineLearningImage,
    views: 1850
  },
  {
    slug: "preparing-for-major-test",
    title: "Preparing for a Major Test? Here are Some Things I Did that Made a Huge Difference",
    excerpt: "Learn proven test preparation strategies that actually work. From creating realistic study plans to managing time and energy, discover methods that made a huge difference in my exam results.",
    date: "2024-12-16",
    readTime: "12 min read",
    category: "Study Tips",
    image: testPrepImage,
    views: 1720
  },
  {
    slug: "top-10-digital-tools-for-academic-success",
    title: "My Top 10 Essential Digital Tools for Academic Success in 2025",
    excerpt: "Discover the 10 essential digital tools every college student needs in 2025. From online study rooms to note-taking apps, these tools will help you ace your academics.",
    date: "2024-12-16",
    readTime: "15 min read",
    category: "Study Tips",
    image: digitalToolsImage,
    views: 1580
  },
  {
    slug: "how-to-stop-procrastination",
    title: "How to Stop Procrastination",
    excerpt: "Procrastination is something all of us have faced at one time or another. It's that quiet, sneaky voice that oftentimes convinces us to put off what we need to work on for tomorrow. Learn practical strategies to overcome it.",
    date: "2024-12-16",
    readTime: "10 min read",
    category: "Productivity",
    image: stopProcrastinationImage,
    views: 1250
  },
  {
    slug: "how-turning-on-my-camera-boosted-my-productivity",
    title: "How Turning on my Camera Boosted my Productivity",
    excerpt: "I used to think that I could never study at home. That's because when I'm in my room, there's no one watching and no pressure to push. My room was therefore my biggest productivity trap.",
    date: "2024-12-07",
    readTime: "8 min read",
    category: "Productivity",
    image: cameraProductivityImage,
    views: 980
  }
];

const categories = [
   { name: "Focus & Productivity", count: 1 },
   { name: "Productivity", count: 7 },
  { name: "Study Tips", count: 2 },
  { name: "Online Learning", count: 1 },
  { name: "Self-Growth", count: 1 },
  { name: "Time Management", count: 0 }
];

const Blog = () => {
  const recentPosts = [...blogPosts].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 3);
  const popularPosts = [...blogPosts].sort((a, b) => b.views - a.views).slice(0, 3);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <SEO 
        title="Blog - Productivity Tips & Study Guides"
        description="Discover productivity tips, study techniques, and insights on how to stay focused with online study rooms. Learn from real experiences and boost your productivity."
        keywords="productivity blog, study tips, online study rooms, focus techniques, study with me, productivity hacks"
        canonicalUrl="/blog/"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-background to-background" />
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 bg-secondary/10 rounded-full blur-3xl" />
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <span className="inline-block px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
              CSW Blog
            </span>
            <h1 className="text-4xl md:text-6xl font-display font-bold mb-6">
              Productivity <span className="text-gradient">Insights</span> & Tips
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Real stories, practical advice, and study techniques to help you stay focused and achieve your goals.
            </p>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid with Sidebar */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12 max-w-7xl mx-auto">
            
            {/* Main Content */}
            <div className="flex-1 space-y-8">
              {blogPosts.map((post) => (
                <Link 
                  key={post.slug}
                  to={`/blog/${post.slug}/`}
                  className="group block"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  <article className="bg-card border border-border rounded-2xl overflow-hidden hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/5">
                    <div className="flex flex-col md:flex-row">
                      <div className="md:w-1/3">
                        <img 
                          src={post.image} 
                          alt={post.title}
                          className="w-full h-48 md:h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                      </div>
                      <div className="p-6 md:p-8 md:w-2/3">
                        <div className="flex flex-wrap items-center gap-3 mb-4">
                          <span className="px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium">
                            {post.category}
                          </span>
                          <div className="flex items-center gap-2 text-muted-foreground text-sm">
                            <Calendar className="w-4 h-4" />
                            <span>{new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                          </div>
                          <div className="flex items-center gap-2 text-muted-foreground text-sm">
                            <Clock className="w-4 h-4" />
                            <span>{post.readTime}</span>
                          </div>
                        </div>
                        
                        <h2 className="text-xl md:text-2xl font-display font-bold mb-3 group-hover:text-primary transition-colors">
                          {post.title}
                        </h2>
                        
                        <p className="text-muted-foreground mb-4 line-clamp-2 text-sm md:text-base">
                          {post.excerpt}
                        </p>
                        
                        <div className="flex items-center gap-2 text-primary font-medium text-sm">
                          Read More <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                        </div>
                      </div>
                    </div>
                  </article>
                </Link>
              ))}
            </div>

            {/* Sidebar */}
            <aside className="lg:w-80 space-y-8">
              
              {/* Categories */}
              <div className="bg-card border border-border rounded-2xl p-6">
                <div className="flex items-center gap-2 mb-5">
                  <Tag className="w-5 h-5 text-primary" />
                  <h3 className="text-lg font-display font-bold">Categories</h3>
                </div>
                <ul className="space-y-3">
                  {categories.map((category) => (
                    <li key={category.name}>
                      <button 
                        className="w-full flex items-center justify-between px-4 py-2.5 rounded-xl bg-muted/50 hover:bg-primary/10 hover:text-primary transition-colors text-left"
                        disabled={category.count === 0}
                      >
                        <span className={category.count === 0 ? "text-muted-foreground" : ""}>{category.name}</span>
                        <span className="text-sm text-muted-foreground bg-background px-2 py-0.5 rounded-full">
                          {category.count}
                        </span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Recent Posts */}
              <div className="bg-card border border-border rounded-2xl p-6">
                <div className="flex items-center gap-2 mb-5">
                  <Sparkles className="w-5 h-5 text-primary" />
                  <h3 className="text-lg font-display font-bold">Recent Posts</h3>
                </div>
                <ul className="space-y-4">
                  {recentPosts.map((post) => (
                    <li key={post.slug}>
                      <Link 
                        to={`/blog/${post.slug}/`}
                        onClick={() => window.scrollTo(0, 0)}
                        className="group flex gap-3"
                      >
                        <img 
                          src={post.image} 
                          alt={post.title}
                          className="w-16 h-16 object-cover rounded-lg flex-shrink-0"
                        />
                        <div className="flex-1 min-w-0">
                          <h4 className="font-medium text-sm line-clamp-2 group-hover:text-primary transition-colors">
                            {post.title}
                          </h4>
                          <p className="text-xs text-muted-foreground mt-1">
                            {new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                          </p>
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Popular Articles */}
              <div className="bg-card border border-border rounded-2xl p-6">
                <div className="flex items-center gap-2 mb-5">
                  <TrendingUp className="w-5 h-5 text-primary" />
                  <h3 className="text-lg font-display font-bold">Popular Articles</h3>
                </div>
                <ul className="space-y-4">
                  {popularPosts.map((post, index) => (
                    <li key={post.slug}>
                      <Link 
                        to={`/blog/${post.slug}/`}
                        onClick={() => window.scrollTo(0, 0)}
                        className="group flex gap-3 items-start"
                      >
                        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary font-bold text-sm flex-shrink-0">
                          {index + 1}
                        </span>
                        <div className="flex-1 min-w-0">
                          <h4 className="font-medium text-sm line-clamp-2 group-hover:text-primary transition-colors">
                            {post.title}
                          </h4>
                          <p className="text-xs text-muted-foreground mt-1">
                            {post.views.toLocaleString()} views
                          </p>
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA Card */}
              <div className="bg-gradient-to-br from-primary/10 to-secondary/10 border border-primary/20 rounded-2xl p-6 text-center">
                <h3 className="font-display font-bold mb-3">Join Our Study Community</h3>
                <p className="text-sm text-muted-foreground mb-4">
                  Study with thousands of others in our free online study rooms.
                </p>
                <a 
                  href="https://app.csw.live"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center px-6 py-2.5 bg-primary text-primary-foreground rounded-xl font-medium text-sm hover:bg-primary/90 transition-colors"
                >
                  Try CSW Free
                </a>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
